<div class="public-container">
  <div class="left-side-container">
    <!-- Logo container -->
    <figure>
      <img src="assets/images/logo.svg" alt="SBI" />
    </figure>

    <!-- Main form -->
    <form
      *ngIf="!(invalidActivationKey$ | async)"
      [formGroup]="activationForm"
      (submit)="onUserSubmit()"
      class="activation-form"
      [class.form-loading]="activatingUser$ | async"
    >
      <h2 class="public-form-title">Activar cuenta</h2>
      <p>Crear una contraseña para comenzar a utilizar el portal.</p>

      <!-- Password -->
      <div class="field-wrapper">
        <custom-text-field
          [type]="'password'"
          formControlName="password"
          label="Contraseña"
          inputId="password"
          [errors]="passwordErrors"
        ></custom-text-field>
      </div>

      <!-- Password Validation Indicators -->
      <app-password-validation-indicators
        [passwordControl]="activationForm.get('password')!"
      ></app-password-validation-indicators>

      <!-- Repeat Password -->
      <div class="field-wrapper">
        <custom-text-field
          [type]="'password'"
          formControlName="passwordRepeat"
          label="Reingresar contraseña"
          inputId="passwordRepeat"
          [errors]="repeatPasswordErrors"
        ></custom-text-field>
        <!-- Password match success message -->
        <p
          class="password-match-success"
          *ngIf="
            activationForm.get('passwordRepeat')!.value &&
            !activationForm.get('passwordRepeat')!.hasError('passwordMismatch')
          "
        >
          Las contraseñas coinciden
        </p>
      </div>

      <!-- Submit Button -->
      <div class="button-container">
        <button
          type="submit"
          class="submit-button"
          [disabled]="activationForm.invalid || (activatingUser$ | async)"
        >
          <i
            class="pi submit-button__icon"
            [ngClass]="
              (activatingUser$ | async) ? 'pi-spin pi-spinner' : 'pi-check'
            "
          ></i>
          <span class="submit-button__text">Activar cuenta</span>
        </button>
      </div>
    </form>

    <!-- Invalid password key -->
    <div *ngIf="invalidActivationKey$ | async" class="invalid-password-key">
      <h2 class="public-form-title">Activar cuenta</h2>
      <p class="expired-text">
        El tiempo para activar la cuenta ha expirado, o el usuario ya fue
        activado. Podés escribirnos a nuestro email, whatsapp o llamarnos.
      </p>

      <div class="comunication-modes">
        <span><i class="fab fa-whatsapp"></i> 094 724 724</span>
        <span><i class="fas fa-phone"></i> 0800 0724</span>
        <span><i class="fas fa-envelope"></i> consultas&#64;sbi.uy</span>
      </div>

      <!-- Button -->
      <a routerLink="/" class="back-link">
        <i class="fas fa-chevron-left"></i>
        Volver al inicio de sesión
      </a>
    </div>

    <!-- Footer -->
    <footer>© 2020 Todos los derechos reservados.</footer>
  </div>
</div>
